export default "__VITE_ASSET__507e3796__"